import canCourse from 'api/access/CanCourse'
import { AccessTypesEnum } from 'enum/access.enum'
import { ICoursePermissions } from 'store/states/access.state'

export const canBeHere = async (
  courseId: number | string,
  permissionType: AccessTypesEnum[]
) => {
  return canCourse(courseId).then(({ data: permissions }: any) => {
    const haveOne = permissionType.some(
      (requiredPermission: string) => permissions[requiredPermission]
    )

    if (!haveOne) {
      window.location.href = '/forbidden'
    }
    return {
      ...permissions,
      id: courseId,
      loading: false,
    } as ICoursePermissions
  })
}

export const onHttpError = (err: any) => {
  if (err.response?.status === 403) window.location.href = '/forbidden'
  if (err.response?.status === 404) window.location.href = '/notFound'
}
